import { Component, Input } from '@angular/core'
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap'

@Component({
    selector: 'segments-list-modal',
    templateUrl: './history-modal.component.html',
})
export class HistoryModal {
    constructor(private activeModal: NgbActiveModal) {}

    @Input() translatedHistory: any[] = []
    historiesOfActualPage: any[] = []
    @Input() translatedAmountOfHistoryEvents = 0
    showGetHistoryTranslationLoader = false

    // Paginação
    actualPage = 1
    amountRegistersPerPage = 0
    historyEventsTotalOfPages = 0

    ngOnInit() {
        if (this.translatedHistory.length == 0) return
        let initHistoriesOfActualPage = [...this.translatedHistory]

        this.historiesOfActualPage = initHistoriesOfActualPage.splice(0, 10)

        let historyEventsTotalOfPages: any

        if (this.translatedAmountOfHistoryEvents % 10 !== 0)
            historyEventsTotalOfPages = this.translatedAmountOfHistoryEvents / 10 + 1
        else historyEventsTotalOfPages = this.translatedAmountOfHistoryEvents / 10

        this.historyEventsTotalOfPages = parseInt(historyEventsTotalOfPages)
    }

    historyPreviousPage() {
        if (this.actualPage > 1) {
            this.actualPage--

            this.historiesOfActualPage = this.translatedHistory.slice(
                (this.actualPage - 1) * 10,
                this.actualPage * 10,
            )
        }
    }

    historyNextPage() {
        if (this.actualPage + 1 <= this.historyEventsTotalOfPages) {
            this.actualPage++

            this.historiesOfActualPage = this.translatedHistory.slice(
                (this.actualPage - 1) * 10,
                this.actualPage * 10,
            )
        }
    }

    closeConfirmModal() {
        this.activeModal.close()
    }
}
